export var BrandColor;
(function (BrandColor) {
    BrandColor["lounge"] = "var(--brand-color--lounge)";
    BrandColor["primary"] = "var(--brand-color--primary)";
})(BrandColor || (BrandColor = {}));
export var SocialColor;
(function (SocialColor) {
    SocialColor["facebookBlue"] = "var(--social-color--facebookBlue)";
    SocialColor["facebookDarkBlue"] = "var(--social-color--facebookDarkBlue)";
    SocialColor["gmailGrey"] = "var(--social-color--gmailGrey)";
})(SocialColor || (SocialColor = {}));
export var FunctionColor;
(function (FunctionColor) {
    FunctionColor["function100"] = "var(--function-color--function100)";
    FunctionColor["function80"] = "var(--function-color--function80)";
    FunctionColor["function60"] = "var(--function-color--function60)";
    FunctionColor["function40"] = "var(--function-color--function40)";
    FunctionColor["function20"] = "var(--function-color--function20)";
    FunctionColor["function10"] = "var(--function-color--function10)";
    FunctionColor["function5"] = "var(--function-color--function5)";
    FunctionColor["function0"] = "var(--function-color--function0)";
})(FunctionColor || (FunctionColor = {}));
export var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["neutral"] = "var(--background-color--neutral)";
    BackgroundColor["alert"] = "var(--background-color--alert)";
    BackgroundColor["success"] = "var(--background-color--success)";
    BackgroundColor["info"] = "var(--background-color--info)";
    BackgroundColor["cosy"] = "var(--background-color-cosy)";
})(BackgroundColor || (BackgroundColor = {}));
export var SupportingColor;
(function (SupportingColor) {
    SupportingColor["alert"] = "var(--supporting-color--alert)";
    SupportingColor["success"] = "var(--supporting-color--success)";
    SupportingColor["info"] = "var(--supporting-color--info)";
})(SupportingColor || (SupportingColor = {}));
export var ComplementaryColor;
(function (ComplementaryColor) {
    ComplementaryColor["cool"] = "var(--complementary-color--cool)";
    ComplementaryColor["cool60"] = "var(--complementary-color--cool60)";
    ComplementaryColor["cool30"] = "var(--complementary-color--cool30)";
    ComplementaryColor["cool20"] = "var(--complementary-color--cool20)";
    ComplementaryColor["vivid"] = "var(--complementary-color--vivid)";
    ComplementaryColor["vivid60"] = "var(--complementary-color--vivid60)";
    ComplementaryColor["vivid30"] = "var(--complementary-color--vivid30)";
    ComplementaryColor["vivid20"] = "var(--complementary-color--vivid20)";
    ComplementaryColor["warm"] = "var(--complementary-color--warm)";
    ComplementaryColor["warm60"] = "var(--complementary-color--warm60)";
    ComplementaryColor["warm30"] = "var(--complementary-color--warm30)";
    ComplementaryColor["warm20"] = "var(--complementary-color--warm20)";
    ComplementaryColor["brand30"] = "var(--complementary-color--brand30)";
    ComplementaryColor["brand20"] = "var(--complementary-color--brand20)";
    ComplementaryColor["info30"] = "var(--complementary-color--info30)";
    ComplementaryColor["fresh"] = "var(--complementary-color--fresh)";
    ComplementaryColor["fresh30"] = "var(--complementary-color--fresh30)";
    ComplementaryColor["fresh20"] = "var(--complementary-color--fresh20)";
    ComplementaryColor["neonFresh"] = "var(--complementary-color--neon-fresh)";
    ComplementaryColor["neonCool"] = "var(--complementary-color--neon-cool)";
    ComplementaryColor["neonCrisp"] = "var(--complementary-color--neon-crisp)";
})(ComplementaryColor || (ComplementaryColor = {}));
export const browserFocusOutlineColor = SupportingColor.info;
//# sourceMappingURL=index.js.map